export default "__VITE_ASSET__BVxLeCXl__"